document.addEventListener('DOMContentLoaded', function () {
    let pressIncrementElements = document.querySelectorAll('.press-increment');
    pressIncrementElements.forEach(function (element) {
        element.addEventListener('click', function () {
            let cardId = this.getAttribute('data-id');
            $.ajax({
                url: `${location.pathname}?id=${cardId}`,
                method: 'post',
            }).done(res => {
            })
        });
    });
});